import { IAboutDetails } from '@/interfaces/IAboutUsData'
import styles from './WhoWeAreSection.module.css'
import Image from 'next/image'
type props = {
    whoWeAreData: IAboutDetails
}
export function WhoWeAreSection({ whoWeAreData }: props) {
    return <><section className={styles.outText}>
        <div className="container">
            <h2 className={`${styles.sectionHeading} sectionHeading`}>{whoWeAreData.who_we_are_title}</h2>
            <div className={styles.aboutTextBox}>
                <div className={styles.textBox}>
                    <span className="font18 fontThin text666 lineHeight23 mb25" dangerouslySetInnerHTML={{ __html: whoWeAreData.who_we_are_content }} />
                </div>
                <figure className={styles.imageBox}>
                    <Image src={whoWeAreData.who_we_are_image} className="imgResponsive" alt={whoWeAreData.who_we_are_title} height={364} width={620} />
                </figure>
            </div>
        </div>
    </section>
        <section className={`${styles.outText} ${styles.outTextBg}`}>
            <div className="container">
                <h2 className={`${styles.sectionHeading} sectionHeading`}>{whoWeAreData.our_mission_title}</h2>
                <div className={`${styles.aboutTextBox} ${styles.aboutTextReverse}`}>
                <div className={styles.textBox}>
                        <span className="font18 fontThin text666 lineHeight23 mb25"dangerouslySetInnerHTML={{ __html: whoWeAreData.our_mission_content }} />
                    </div>
                    <figure className={styles.imageBox}>
                        <Image src={whoWeAreData.our_mission_image} className="imgResponsive" alt={whoWeAreData.our_mission_title} height={364} width={620} />
                    </figure>
                </div>
            </div>
        </section>
       </>
}